export default "<p>type-document works!</p>\r\n<app-object-state [concept]=\"concept\" [object]=\"object\" [user]=\"user\"></app-object-state>\r\n";